import React from 'react';
import './styles.scss';

/**
 * Premium Data Review Modal
 * Encapsulated within its own DataReviewModal folder for modular architecture.
 */
export default function DataReviewModal({ label, rows, onClose }) {
  if (!rows || rows.length === 0) return null;
  const cols = Object.keys(rows[0]).filter(k => k !== 'year');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content analytics-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title-group">
            <span className="verify-badge">🔍 Full Audit Log</span>
            <h2 className="modal-title">{label} • {rows.length} Total Records</h2>
          </div>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body custom-scrollbar">
          <table className="preview-table full-width-table">
            <thead>
              <tr>{cols.map(c => <th key={c}>{c}</th>)}</tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>{cols.map(c => <td key={c}>{r[c]}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn-close-large" onClick={onClose}>Close Review</button>
        </div>
      </div>
    </div>
  );
}
